import React from 'react'
import { MockedProvider } from 'react-apollo/test-utils'
import { mount, shallow } from 'enzyme'
import OrderTranscriptsModalProps from './testData/OrderTranscriptsModalProps'
import { OrderTranscriptsModal } from '../modals/OrderTranscriptsModal'
import TaxForm from '../forms/TaxForm'
import Button from '../../common/Button'
import loan from './testData/loan'


describe('<OrderTranscriptsModal />', () => {
  let wrapper, instance
  const noop = () => { }
  const validFormData = {
    name: 'Kek T. Washingstone',
    endDate: '12/31',
    tin: '042-44-9912',
    street: '892 4th Ave',
    apt: 9948,
    city: 'San Francisco',
    state: 'California'
  }
  const invalidFormData = {
    name: 'Bob Ross',
    endDate: '12/31',
    tin: '023444',
    street: '10 8th Street',
    apt: 2234,
    city: 'San Francisco',
    state: 'California'
  }
  const props = {
    ...OrderTranscriptsModalProps,
    taxReturnOrderInfo: noop,
    orderTaxTranscripts: noop,
    documentHeaderImage: noop,
    close: noop
  }
  const formData = {
    1040: [
      {
        name: 'John Doe',
        tin: '234-22-4813',
        address: '238 8th Street',
        apt: 482,
        city: 'San Francisco',
        state: 'California',
        zip: '47239',
        valid: true
      },
      {
        // Test secondTin being blank with presence of secondName
        name: 'Jack Smith',
        secondName: 'Jane Smith',
        tin: '442-33-9034',
        secondTin: '',
        address: '5323 Oak Ridge Road',
        apt: 444,
        city: 'Chicago',
        state: 'Illinois',
        zip: '09637',
        valid: false
      },
      {
        // Test secondName being blank with presence of secondTin
        name: 'Jack Smith',
        secondName: '',
        tin: '442-33-9034',
        secondTin: '442-90-3324',
        address: '5323 Oak Ridge Road',
        apt: 444,
        city: 'Chicago',
        state: 'Illinois',
        zip: '09637',
        valid: false
      },
      {
        name: 'asdf',
        tin: '234-47-4826',
        address: '424 99th Ave',
        apt: 1,
        city: 'St. Louis',
        state: 'Missouri',
        zip: '22342',
        valid: false
      },
      {
        name: 'John C. Riley',
        tin: '134',
        address: 'this is an address',
        apt: 4,
        city: 'Dallas',
        state: 'Texas',
        zip: '29445',
        valid: false
      }
    ],
    everythingElse: [
      {
        name: 'Bob Ross',
        tin: '435-09-5748',
        address: '89 49th Street',
        apt: 4453,
        city: 'Newark',
        state: 'New Jersey',
        zip: '42451',
        valid: true
      },
      {
        name: 'Jim Jones',
        tin: '42',
        address: '',
        apt: 424,
        city: 'San Leandro',
        state: 'California',
        zip: '88549',
        valid: false
      }
    ]
  }

  beforeAll( () => {
    wrapper = mount(
      <OrderTranscriptsModal {...props} />
    )
    instance = wrapper.instance()
  })

  it('should render without crashing', () => {
    mount(
      <OrderTranscriptsModal {...props} />
    )
  })

  describe('#renderHeader', () => {
    it('should return component', () => {
      const obj = instance.renderHeader()
      const textValue = wrapper.find('small').at(0)

      expect(textValue.text()).toEqual("Please verify that the information is correct and then electronically sign the order form.");
      expect(JSON.stringify(obj)).toContain("Test Biz's")
    })
  })

  describe('#renderFormSelect', () => {

    it('should return id', () => {
      const obj = instance.renderFormSelect()

      expect(JSON.stringify(obj)).toContain("tax_form_select")
    })

    it('should render form options', () => {
      const obj = instance.renderFormSelect()

      expect(JSON.stringify(obj)).toContain("Form 1065 U.S. Return of Partnership Income",
                                            "Form 1120 U.S. Corporation Income Tax Return",
                                            "Form 1040 Individual Income Tax Return",
                                            "Form 1120S U.S. Corporation Income Tax Return")
    })
  })

  describe('#renderTaxYearSelect', () => {
    it('should return id', () => {
      const obj = instance.renderTaxYearSelect()

      expect(JSON.stringify(obj)).toContain('tax_year_select')
    })
  })

  describe('#renderTaxReturn', () => {
    props.entity.taxReturnUrls = [{
      "date": 2020,
      "value": "/admin/loans/224100/download_file?document=5090611", "label": "2020", "\__typename": "SelectorOption", "Symbol(id)": 'SelectorOption/admin/loans/224100/download_file?document=50906112019'
    }]

    it('should render id', () => {
      const obj = instance.renderTaxReturn()

      expect(JSON.stringify(obj)).toContain('last_tax_return')
    })

    it('should return component', () => {
      const textValue = wrapper.find('p').at(0)

      expect(textValue.text()).toEqual("Here is the most recent tax return:2020 Tax Return");
    })
  })

  describe('#renderHeaderImage', () => {
    it('should return components', () => {
      wrapper.setState({ headerImageUrl: '/admin/images' })
      const obj = instance.renderHeaderImage()

      expect(JSON.stringify(obj)).toContain('Periods', 'Commas', 'Capitalization')
    })
  })

  describe('#renderFooter', () => {
    describe('when closeButton is clicked', () => {
      let onCloseFunc;

      it('should be true', () => {
        onCloseFunc = jest.fn()
        props.close = onCloseFunc;
        wrapper = mount(
          <OrderTranscriptsModal {...props} />
        )
        wrapper.find('button').at(0).simulate('click')

        expect(onCloseFunc).toBeCalled()
      })
    })

    describe('when submitButton is clicked', () => {
      let onSubmitMockFunc;
      const mockedCall = async () => {
        try {
          return {
            loading: false,
            loans: {},
          };
        } catch {
          return "test";
        }
      };

      it('should be true', () => {
        wrapper = mount(
          <OrderTranscriptsModal {...props} />
        )
        instance = wrapper.instance()
        onSubmitMockFunc = jest.spyOn(instance, 'onSubmit').mockReturnValue(mockedCall)
        instance.onSubmit()

        expect(onSubmitMockFunc).toBeCalled()
      })

    })
  })

  describe('#renderFormInput', () => {
    beforeEach( () => {
      props.entity = {
        taxAddress: {
          "apt": null,
          "rid": 91234,
          "city": "Saratoga",
          "street": "12345 Main Street",
          "state": "CA",
          "zip": 95070
        },
        taxReturnUrls: [{
          "date": 2017,
          "value": "/admin/loans/224100/download_file?document=5090611", "label": "2017", "\__typename": "SelectorOption", "Symbol(id)": 'SelectorOption/admin/loans/224100/download_file?document=50906112019'
        }],
        taxReturns: [{
          formId: 1,
          rid: 54634,
          formName: "1065",
          tin: '12333',
          name: 'Test Business',
          year: 2017
        }]
      }
      wrapper.setProps({ ...props })
      instance = wrapper.instance()
    })

    it('should render defaults', () => {
      wrapper.setState({ yearSelected: 2017 })
      wrapper.setState({ extractionSuccess: true })
      const obj = instance.renderTaxReturn()

      expect(wrapper.find(TaxForm)).toHaveLength(1)
      expect(wrapper.find((TaxForm)).props('defaultValue').defaults.tin).toEqual('12333')
      expect(wrapper.find((TaxForm)).props('defaultValue').defaults.name).toEqual('Test Business')
    })

  })

  // it('should correctly validate data from Form 1040', () => {
  //   const wrapper = shallow(
  //     <OrderTranscriptsModal {...props} />
  //   )
  //   const instance = wrapper.instance()
  //   for (const data of formData['1040']) {
  //     const testData = { ...data }
  //     // This step is necessary to
  //     delete testData.valid
  //     expect(instance.validate(testData)).toEqual(data.valid)
  //   }
  // })
  // it('should correctly validate data from all other tax forms (1065, 1120, 1120S)', () => {
  //   const wrapper = shallow(
  //     <OrderTranscriptsModal {...props} />
  //   )
  //   const instance = wrapper.instance()
  //   for (const data of formData.everythingElse) {
  //     const testData = { ...data }
  //     // This step is necessary to
  //     delete testData.valid
  //     expect(instance.validate(testData)).toEqual(data.valid)
  //   }
  // })
})